import { render } from "./empty-search-state.vue?vue&type=template&id=a922b50a"
import script from "./empty-search-state.vue?vue&type=script&lang=js"
export * from "./empty-search-state.vue?vue&type=script&lang=js"

import "./empty-search-state.vue?vue&type=style&index=0&id=a922b50a&lang=scss"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__